import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface Data {
  lists: string[];
}

interface Props {
  topic: any;
	onSuccess?: () => void;
  onError?: (res: AxiosError) => void;
}

export const useSetListsToNoteTopic = ({
  topic,
	onSuccess,
  onError
}: Props) => {
	const queryClient = useQueryClient();
  const {
		mutate: onSetListsToNoteTopic,
		variables,
		...rest
	} = useMutation({
	mutationFn: async ({ lists: listIds }: Data) => await axios.post(`/note-topics/${topic.id}/lists`, { listIds }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['topics', { noteId: topic.noteId }] });

			if (onSuccess)
				onSuccess();
		},
    onError
	});

	return { onSetListsToNoteTopic, variables, ...rest };
};
